import Tooltip from "../../../../components/tooltip";
import Simulation from "./Generation/SimulationPPEConsole";
import SurplusDeficitAnalysis from "./Generation/SimulationDeficit";
import SimulationHeader from "../utility/SimulationHeader";
import { useCallback, useEffect, useState } from "react";
import { useOptimizerNavigation } from "../utility/useOptimizerNavigation";
import MainHeader from "../utility/DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import DateRangeSelector from "../DateRange/DateRangeSelector";
import { useSelector } from "react-redux";
import Loading from "../../../../components/Loading";
import ToggleTabs from "../utility/ChartTableToggle";
import RuvnlOptimalIndex from "../OptimalProcurement/OptimalIndex";
import MetricsProcurement from "../MetricsProcurement/MetricsIndex";
import GnaMetricsCostAnalysis from "./Generation/GnaMetrics/GnaMetricsCost";
import GnaMetricsVolumeAnalysis from "./Generation/GnaMetrics/GnaMetricsVolume";
import { fetchProcurementSimulationMetricsData } from "../../../../Rest_api/DemoRestApi";
const DataTabs = ["Volume", "Cost"];
const MainTabs = ["Simulation", "Optimal", "Metrics"];

export default function RuvnlSimulationIndex() {
  const { navigateToPage } = useOptimizerNavigation();
  const [activeMainTab, setActiveMainTab] = useState(MainTabs[0]);
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);

  const preSelectedstartDate = useSelector(
    (state: any) => state.ProcurementOptimizerDemoDate.startDate
  );
  const preSelectedendDate = useSelector(
    (state: any) => state.ProcurementOptimizerDemoDate.endDate
  );
  const [selectedTargetDate, setSelectedTargetDate] = useState<
    Array<{ value: string; label: string; isFixed: boolean }>
  >([]);
  const handleDateChange = (
    start: Date | null,
    end: Date | null,
    allDates: Array<{ value: string; label: string; isFixed: boolean }>
  ) => {
    setSelectedTargetDate(allDates);
  };

  const handleFetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetchProcurementSimulationMetricsData();
      const res = [response];
      setData(res);
    } catch (error) {
      console.error("Error fetching data", error);
      setError?.("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="w-full overflow-hidden">
        {loading && <Loading />}
        <MainHeader />
        <div className="h-[calc(-85px+100vh)] p-4 overflow-hidden">
          <div className="w-full h-full flex flex-col gap-4 overflow-hidden">
            <SimulationHeader
              title={
                activeMainTab === "Simulation"
                  ? "Simulated Portfolio"
                  : activeMainTab === "Optimal"
                  ? "Optimised Portfolio"
                  : "Portfolio Metrics"
              }
              activeTab={activeMainTab}
              setActiveTab={setActiveMainTab}
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
            />
            <div className="flex flex-row gap-4 relative flex-1 min-h-0 overflow-hidden">
              <Simulation
                open={open}
                setOpen={setOpen}
                setError={setError}
                refreshKey={refreshKey}
                setRefreshKey={setRefreshKey}
                activeTab={activeMainTab}
              />

              <div
                className="gas-chart-container !p-4  shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl flex flex-col min-w-0"
                style={{
                  height: "100%",
                  flex: 1,
                  overflow: "hidden",
                }}
              >
                {activeMainTab === "Simulation" && (
                  <div className="flex flex-col h-full w-full min-w-0 overflow-hidden">
                    {/* Header with Date Range and Tabs - Fixed height */}
                    <div className="flex justify-between items-center mb-3 border-b border-[#DFEAF2] bg-[#FFF] pb-2 flex-shrink-0 min-w-0">
                      <div className="flex items-center gap-3 min-w-0">
                        <DateRangeSelector
                          placeholder="Select Date Range"
                          startDate={preSelectedstartDate}
                          endDate={preSelectedendDate}
                          onDateChange={handleDateChange}
                        />
                      </div>
                      <div className="flex gap-x-6 justify-end flex-shrink-0">
                        <ToggleTabs
                          tabs={DataTabs}
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                        />
                      </div>
                    </div>

                    {/* Content area - Takes remaining height */}
                    <div className="flex flex-col gap-3 flex-1 min-h-0 min-w-0 overflow-hidden !bg-[#FCFCFCB8]">
                      {/* Metrics Cards Row - Auto height based on content */}
                      <div className="w-full flex-shrink-0 min-w-0 overflow-hidden">
                        {activeTab === "Volume" && (
                          <GnaMetricsVolumeAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            loading={loading}
                            data={data}
                          />
                        )}
                        {activeTab === "Cost" && (
                          <GnaMetricsCostAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            loading={loading}
                            data={data}
                          />
                        )}
                      </div>

                      {/* Charts Row - Takes remaining space */}
                      <div className="w-full flex-1 min-h-0 min-w-0 overflow-hidden">
                        {activeTab === "Volume" && (
                          <SurplusDeficitAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            setUniqueTargetDate={setUniqueTargetDate}
                            selectedTargetDate={selectedTargetDate}
                            activeTab={activeTab}
                          />
                        )}
                        {activeTab === "Cost" && (
                          <SurplusDeficitAnalysis
                            selectedBlock={selectedBlock}
                            refreshKey={refreshKey}
                            setError={setError}
                            setUniqueTargetDate={setUniqueTargetDate}
                            selectedTargetDate={selectedTargetDate}
                            activeTab={activeTab}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {activeMainTab === "Optimal" && (
                  <RuvnlOptimalIndex refreshKey={refreshKey} />
                )}
                {activeMainTab === "Metrics" && (
                  <MetricsProcurement refreshKey={refreshKey} />
                )}
              </div>
            </div>
          </div>
        </div>

        <ErrorPopup error={error} onClose={() => setError(null)} />
        <div className="gna-footer-container">
          <div className="grid grid-cols-3 justify-between gap-5">
            <Tooltip
              note={
                <p>
                  {/* Default values and variable charges are auto-fetched from
                  system. */}
                </p>
              }
              text=""
            >
              <p className="gna-footer-text">Source</p>
            </Tooltip>
            <p className="gna-footer-text col-span-1 text-center">
              Powered by <strong>GNA Energy</strong>
            </p>
            <strong className="gna-footer-text col-span-1 text-end">
              Beta Version
            </strong>
          </div>
        </div>
      </div>
    </>
  );
}
